import { z } from 'zod';

// Schemas (source of truth)
export const baseAreaSchema = z.object({
	areaId: z.string(),
	areaNick: z.string(),
});

// Types (derived from schemas)
export type IBaseArea = z.infer<typeof baseAreaSchema>;
